<template>
    <validation-observer ref="form" v-slot="{ meta, errors, handleSubmit }" :initial-values="values">
        <modal
            :id="modalId"
            :title="title"
            @ok.prevent="handleSubmit(_, onSubmit)"
            @hidden="clearValues"
            @show="getInitialValues"
            :ok-disabled="!meta.valid || isReadOnly"
            :scrollable="false"
            @shown="setFormValues"
        >
            <busy-modal :show="loading" />
            <div v-if="values">
                <b-row v-if="properties" class="no-gutters">
                    <b-col md="12">
                        <validation-provider v-slot="{ field }" name="rental_property" rules="required">
                            <form-select
                                v-bind="field"
                                :options="properties"
                                floatingLabel="Property"
                                :error="errors.rental_property"
                                :disabled="isReadOnly || isOnlineReview"
                            />
                        </validation-provider>
                    </b-col>
                </b-row>
                <b-row v-if="languages" class="no-gutters">
                    <b-col md="12">
                        <validation-provider v-slot="{ field }" name="language" rules="required">
                            <form-select
                                v-bind="field"
                                :options="languages"
                                floatingLabel="Language"
                                :error="errors.language"
                                :disabled="isReadOnly || isOnlineReview"
                            />
                        </validation-provider>
                    </b-col>
                </b-row>
                <b-row class="no-gutters">
                    <b-col md="6" class="pr-1">
                        <validation-provider v-slot="{ field, handleChange }" name="date" rules="required">
                            <form-datepicker
                                v-bind="field"
                                floatingLabel="Date"
                                :hide-header="true"
                                :display-format="userUnicodeDateFormat"
                                :error="errors.date"
                                :disabled="isReadOnly || isOnlineReview"
                                @input="handleChange"
                            />
                        </validation-provider>
                    </b-col>
                    <b-col md="6">
                        <validation-provider v-slot="{ field }" name="stars" rules="required">
                            <form-select
                                v-bind="field"
                                floatingLabel="Stars"
                                :options="starsOptions"
                                :error="errors.stars"
                                :disabled="isReadOnly"
                            />
                        </validation-provider>
                    </b-col>
                </b-row>

                <b-row class="no-gutters">
                    <b-col md="12">
                        <validation-provider v-slot="{ field }" name="name" rules="required|maxMessageLen:101">
                            <form-input
                                v-bind="field"
                                floatingLabel="Name"
                                :error="errors.name"
                                :disabled="isReadOnly"
                            />
                        </validation-provider>
                    </b-col>
                </b-row>
                <b-row class="no-gutters">
                    <b-col md="12">
                        <validation-provider v-slot="{ field }" name="title" rules="maxMessageLen:101">
                            <form-input
                                v-bind="field"
                                :error="errors.title"
                                floatingLabel="Title"
                                :disabled="isReadOnly"
                            />
                        </validation-provider>
                    </b-col>
                </b-row>
                <b-row class="no-gutters">
                    <b-col md="12">
                        <validation-provider v-slot="{ field }" name="description" rules="required">
                            <form-textarea
                                v-bind="field"
                                floatingLabel="Description"
                                :error="errors.description"
                                :rows="4"
                                :disabled="isReadOnly"
                            />
                        </validation-provider>
                    </b-col>
                </b-row>
            </div>
        </modal>
    </validation-observer>
</template>

<script>
    import { mapGetters } from 'vuex';
    import Modal from '../../../generic/modal/modal.vue';
    import FormDatepicker from '../../../generic/form-datepicker/form-datepicker.vue';
    import FormSelect from '../../../generic/form-select/form-select.vue';
    import FormInput from '../../../generic/form-input/form-input.vue';
    import FormTextarea from '../../../generic/form-textarea/form-textarea.vue';
    import BusyModal from '../../../generic/busy-modal/busy-modal.vue';
    import { newReviewObject } from '../constants';
    import SearchMultiselect from '../../../generic/search-multiselect/search-multiselect.vue';
    import format from 'date-fns/format';
    import parseISO from 'date-fns/parseISO';
    import { values } from 'lodash';

    export default {
        components: {
            Modal,
            FormDatepicker,
            FormSelect,
            FormInput,
            FormTextarea,
            BusyModal,
            SearchMultiselect,
        },
        data() {
            return {
                values: null,
                newReviewObject,
            };
        },
        props: {
            modalId: String,
            title: String,
            initValues: Object,
            loading: Boolean,
            properties: Array,
            languages: Array,
            isReadOnly: Boolean,
            isOnlineReview: Boolean,
        },
        computed: {
            ...mapGetters('header', ['userUnicodeDateFormat']),
            starsOptions() {
                return Array.from({ length: 5 }, (v, k) => k + 1).map((item) => ({
                    value: item,
                    text: item,
                }));
            },
        },
        methods: {
            onSubmit(values) {
                this.$emit(
                    'submit',
                    {
                        ...values,
                        date: format(parseISO(values.date), 'yyyy-MM-dd'),
                    },
                    this.modalId
                );
            },
            clearValues() {
                this.values = null;
            },
            getInitialValues() {
                const rental_property = this.properties.length > 0 ? this.properties[0].value : null;
                this.values = this.initValues ? { ...this.initValues, rental_property } : { ...this.newReviewObject };
            },
            setFormValues() {
                this.$refs.form.setValues(this.initValues ? { ...this.initValues } : this.newReviewObject);
                this.$refs.form.validate();
            },
        },
    };
</script>

<style></style>
